import React, { useState, useEffect } from 'react';
import { Table, Form, Input, DatePicker, message, Button } from 'antd';
import { getUsers } from '../services/api';
import moment from 'moment';

const { RangePicker } = DatePicker;

const UserList = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
    const [searchParams, setSearchParams] = useState({});

    const fetchUsers = async (page = 1, pageSize = 10, params = {}) => {
        setLoading(true);
        try {
            const response = await getUsers({ page, per_page: pageSize, ...params });
            setUsers(response.data.users);
            setPagination({ current: page, pageSize, total: response.data.total });
        } catch (error) {
            message.error('获取用户列表失败');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUsers(pagination.current, pagination.pageSize, searchParams);
    }, []);

    const handleTableChange = (pagination) => {
        fetchUsers(pagination.current, pagination.pageSize, searchParams);
    };

    const handleSearch = (values) => {
        const { created_at_range, ...rest } = values;
        const params = {
            ...rest,
            created_at_start: created_at_range ? created_at_range[0].format('YYYY-MM-DD') : '',
            created_at_end: created_at_range ? created_at_range[1].format('YYYY-MM-DD') : '',
        };
        setSearchParams(params);
        fetchUsers(1, pagination.pageSize, params);
    };

    const columns = [
        { title: 'ID', dataIndex: 'id' },
        { title: '用户名', dataIndex: 'username' },
        { title: '是否激活', dataIndex: 'is_active', render: (val) => (val ? '是' : '否') },
        { title: '创建时间', dataIndex: 'created_at' },
    ];

    return (
        <>
            <Form layout="inline" onFinish={handleSearch} style={{ marginBottom: 16 }}>
                <Form.Item name="username" label="用户名">
                    <Input placeholder="输入用户名" />
                </Form.Item>
                <Form.Item name="created_at_range" label="创建时间">
                    <RangePicker />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        搜索
                    </Button>
                </Form.Item>
            </Form>

            <Table
                columns={columns}
                dataSource={users}
                rowKey="id"
                loading={loading}
                pagination={pagination}
                onChange={handleTableChange}
            />
        </>
    );
};

export default UserList;
